export enum IBANCulture {
  BE,
  BG,
  DK,
  DE,
  EE,
  FI,
  FR,
  GR,
  IE,
  IS,
  IT,
  LI,
  LT,
  LU,
  MT,
  MC,
  NL,
  NO,
  AT,
  PL,
  PT,
  RO,
  SE,
  CH,
  SK,
  SI,
  ES,
  CZ,
  HU,
  GB,
  CY,
}